export const ContentCard = {
  LINE: "LINE",
  EMPTY: "EMPTY",
};
